export const getCookie = (key: string): string | undefined => {
    const match = document.cookie.match(new RegExp("(^| )" + key + "=([^;]+)"));
    return match ? match[2] : undefined;
};
